// Mobile AI Study Tools Section - Stacked Feature Cards
import "./ScoutDeskSection.css";

const AI_TOOL_CARDS = [
  {
    key: "flashcards",
    title: "Flashcards",
    subtitle: "Adaptive flashcards built from your actual course material",
    bullets: [
      "Generated from your PDFs, slides, and notes",
      "Focuses on what you don't know",
      "Built for repetition, not memorization dumps"
    ],
    icon: "🏷️"
  },
  {
    key: "quizzes",
    title: "Quizzes",
    subtitle: "Exam-ready practice in minutes",
    bullets: [
      "Multiple-choice from your real coursework",
      "Structured for active recall",
      "Updates automatically as materials change"
    ],
    icon: "🧠"
  },
  {
    key: "podcasts",
    title: "Podcasts",
    subtitle: "Turn readings into listening time",
    bullets: [
      "Study while commuting or training",
      "Choose depth from brief to exhaustive",
      "Built directly from your uploads",
      "For people who learn best when listening to a conversation"
    ],
    icon: "🎧"
  },
  {
    key: "audiobooks",
    title: "Audiobooks",
    subtitle: "When you don't have time to read",
    bullets: [
      "Dense content in digestible audio",
      "Choose length and detail level",
      "Perfect for heavy reading weeks"
    ],
    icon: "📖"
  },
  {
    key: "courseChat",
    title: "Course Chat",
    subtitle: "Answers grounded in your own documents",
    bullets: [
      "Ask questions in full course context",
      "Uses your processed materials",
      "Keeps studying organized by class"
    ],
    icon: "💬"
  }
];

export default function ScoutDeskSection() {
  return (
    <section
      id="ai-study-tools-mobile"
      className="mobileAIStudyTools"
      aria-label="AI Study Tools"
    >
      <div className="mobileAIStudyTools__container">
        {/* Section Header */}
        <div className="mobileAIStudyTools__header">
          <h2 className="mobileAIStudyTools__title">Study tools built for real college life</h2>
          <p className="mobileAIStudyTools__subtitle">
            When you're working, commuting, or catching up late, DocuHounds helps you keep moving.
          </p>
          <div className="mobileAIStudyTools__badge">
            5 tools • 1 workspace • built for real coursework
          </div>
        </div>

        {/* Feature Cards */}
        <div className="featureCards">
          {AI_TOOL_CARDS.map((card) => (
            <div key={card.key} className="featureCard">
              <div className="featureCard__header">
                <div className="featureCard__iconBubble">
                  <span className="featureCard__icon">{card.icon}</span>
                </div>
                <div className="featureCard__text">
                  <h3 className="featureCard__title">{card.title}</h3>
                  <p className="featureCard__subtitle">{card.subtitle}</p>
                </div>
              </div>
              <ul className="featureCard__bullets">
                {card.bullets.map((bullet, index) => (
                  <li key={index}>
                    <span className="featureCard__bulletDot"></span>
                    <span className="featureCard__bulletText">{bullet}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
